// extracted by mini-css-extract-plugin
module.exports = {"textWithIconWrapper":"textWithIconWrapper_9v3rr","icon":"icon_5e7xu","text":"text_2b86g"};